// Module
var code = `<customer-page>

  <form name="\$ctrl.updateForm">
    <h2 class="section-header">Edit loan PDC</h2>
    <table class="table">
      <tbody>
      <tr>
        <td>Amortization no.</td>
        <td>
          <select ng-model="\$ctrl.pdcUpdateRequest.amortizationId"
                  ng-options="a.id as a.lineNumber for a in \$ctrl.amortizations"
                  ng-change="\$ctrl.onAmortizationChange()"
                  required>
          </select>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>Check date</td>
        <td>
          <date ng-model="\$ctrl.pdcUpdateRequest.validFrom"
                ng-required="true"></date>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>Check type</td>
        <td>
          <select ng-model="\$ctrl.pdcUpdateRequest.type"
                  ng-options="checkType | prettyEnum for checkType in \$ctrl.checkTypes"></select>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>Bank</td>
        <td>
          <selectize options="\$ctrl.banks"
                     config="\$ctrl.bankSelectConfig"
                     ng-model="\$ctrl.pdcUpdateRequest.bankId"
                     ng-required="\$ctrl.pdcUpdateRequest.type !== 'ON_US'"
                     ng-disabled="\$ctrl.pdcUpdateRequest.type === 'ON_US'">
          </selectize>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>MICR</td>
        <td>
          <input ng-model="\$ctrl.pdcUpdateRequest.micrNumber"
                 type="text"
                 ui-mask="&#x2448;9999999999&#x2448;99999&#x2449;9999&#x2446;999999999999&#x2448;"
                 ui-options="{clearOnBlur: false}"
                 required/>
        </td>
        <td></td>
      </tr>
      <tr>
        <td>Amount</td>
        <td>
          <cash ng-model="\$ctrl.pdcUpdateRequest.amount"
                ng-required="true"></cash>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </form>

  <div class="clearfix"></div>

  <div class="summary-actions">
    <button type="button"
            class="btn btn-warning"
            ng-click="\$ctrl.onCancelClicked()">
      Cancel
    </button>
    <button type="submit"
            class="btn btn-primary"
            ng-disabled="\$ctrl.updateForm.\$invalid"
            ng-click="\$ctrl.onUpdateClicked()">
      Update
    </button>
  </div>

</customer-page>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/pdc/edit/loan-edit-pdc.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;